import React from 'react'
import { Title, Body } from './styles'
import PropTypes from 'prop-types'
import { OrangeColor } from '../../constants/constants'
import parse from 'html-react-parser'
import { Tooltip } from 'antd'
export const DataBlock = ({ title, body, children, color = OrangeColor, heightBox, printEmpty = false, tooltip }) => {
  if (printEmpty || body.length > 0) {
    return (
      <>
        <Tooltip title={tooltip} placement='topLeft'>
          <Title color={color} data-testid='data-block-title'>
            {title}:
          </Title>
        </Tooltip>
        <Body heightBox={heightBox} data-testid='data-block-body'>
          {parse(body)}
        </Body>
        {children}
      </>
    )
  } else {
    return <div />
  }
}

DataBlock.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  heightBox: PropTypes.string,
  printEmpty: PropTypes.bool,
  tooltip: PropTypes.string
}
